import { createSelector } from "@reduxjs/toolkit";
import { UPLOAD_STATUSES } from "components/Modal/UploadFilesModal/constants";

import { getFolderNode, getRouteNode } from "./navigationNodes";

export const selectChooseFilesModal = (state) => state.chooseFilesModal;

export const selectActiveSource = (state) =>
  state.chooseFilesModal.activeSource;

export const selectIsProcessingFiles = (state) =>
  state?.chooseFilesModal?.processingFiles;

export const selectFiles = createSelector(
  [selectChooseFilesModal],
  (chooseFilesModal) => chooseFilesModal?.files ?? []
);

export const selectFolders = (state) => state.folders;

export const selectfileUploadStates = createSelector(
  [selectFolders],
  (folders) => folders?.fileUploadStates
);

export const selectDocumentId = createSelector(
  [selectFolders],
  (folders) => folders.documentId
);

export const selectFolderId = createSelector(
  [selectFolders],
  (folders) => folders.folderId
);

export const selectFolderName = (state) =>
  state?.workspace?.folderInfo?.folderName || state?.folders?.folderName;

export const selectWorkspace = (state) => state.workspace;

export const selectCurrentFolderInfo = createSelector(
  [selectWorkspace],
  (workspace) => workspace?.folderInfo
);

export const selectNavigationInfo = createSelector(
  [selectWorkspace],
  (workspace) => workspace?.navigationInfo
);

export const selectFolderNode = (state, folderId) =>
  getFolderNode(selectNavigationInfo(state), folderId);

export const selectRouteNode = (state, route) =>
  getRouteNode(selectNavigationInfo(state), route);

export const selectCurrentDocumentInfo = createSelector(
  [selectWorkspace],
  (workspace) => workspace?.documentInfo
);

export const selectStillDownloadingExternally = (state) =>
  state.folders?.stillDownloadingExternally;

export const selectCloudMode = (state) =>
  state.app?.session?.userInfo?.cloudMode ?? false;

export const selectCurrentFlowId = (state) => state.folders?.currentFlowId;

export const selectHasInProgressUpload = (state) => {
  const fileUploadStates = state.folders?.fileUploadStates;
  if (!fileUploadStates) return false;
  const states = Object.values(fileUploadStates);
  if (!states.length) return false;
  return states.some(
    ({ status }) =>
      status !== UPLOAD_STATUSES.COMPLETED && status !== UPLOAD_STATUSES.FAILED
  );
};
